import styled from 'styled-components'

// import theme from 'configs/theme'

const Styled = styled.div`
  .table-component {
    > .company {
      th,
      td {
        font-weight: 900;
      }

      td {
        background: #d9d9d9 !important;
      }

      .group {
        th,
        td {
          font-weight: 800;
        }

        td {
          background: #f4faff !important;
        }

        .bu {
          th,
          td {
            font-weight: 700;
          }

          td {
            background: #f6feff !important;
          }

          .division {
            th,
            td {
              font-weight: 600;
            }

            td {
              background: #dbfbff !important;
            }

            .department {
              th,
              td {
                font-weight: 500;
              }

              td {
                background: #d9d9d9 !important;
              }

              .section {
                th,
                td {
                  font-weight: 400;
                }

                td {
                  background: #f4faff !important;
                }
              }
            }
          }
        }
      }
    }
  }
`

export default Styled
